import { GlobalHelperFunctions } from '../../../../utils/GlobalHelperFunctions';
import './style.scss';

export default class VNextLearningPanel extends UIObject {
  mDiv: JQuery<HTMLElement>;
  timeCreated: number;
  mData: any;
  mSubNavigation: any;

  private _constructorParams: any;
  constructor() {
    super();
  }

  initialize(aConstructorParams: any) {
    this._constructorParams = aConstructorParams;
    this.mDiv = this._generateHtml();
    $('#screens').prepend(this.mDiv);
    this._buildSettings();
    this.setupSubNav();

    addEventListener('popstate', event => {
      // alert('vnow popstate');
    });
  }

  private _generateHtml(): JQuery<HTMLElement> {
    return $(
      HGEN.tree({
        id: 'vnext_learning_panel',
        children: [
          { style: 'subnav_container ui_full_width subnav-font-family' },
          {
            id: 'juno_learning',
            style: 'vnext_learning_container',
          },
        ],
      }),
    );
  }

  public onNavigated(pathObject): void {
    window.JunoWidgetSettings?.widgets.forEach(widget => {
      if (widget?.render) {
        widget.render();
      }
    });
  }

  private _navigateToUserProfile(userEmail: string, key: string) {
    //get vnow user id via email address
    App.INSTANCE.mApi.Request(
      CrowdHub_App.CONFIG.BASE_URL + 'crowdhub_api_v2/api_user_getByEmail.php',
      { email: userEmail },
      success => {
        if (!success.user) {
          return;
        }
        const aUrl = App.INSTANCE.appRouter.generate(key, { id: success.user.user_id });
        App.INSTANCE.route(aUrl);
      },
      function (errorResponse) {
        console.error(errorResponse);
      },
    );
  }

  private _buildSettings(): void {
    const { lessonSlug, courseSlug, tabSlug } = this._constructorParams.urlParams || {};
    const routeKey = App.INSTANCE?.mPathObject.as;

    window.onpopstate = function (e) {
      // need to manually reload when back button is pressed to the initial state
      /*leon is trying to understand why this was here
      if (e.state.idx === 0) {
        location.reload();
      }
      */
    };

    const defaultWidgetProps = App.INSTANCE.defaultVNextWidgetProps();

    this.timeCreated = Date.now();
    this.mData = {
      ...this._constructorParams.data,
      ...defaultWidgetProps,
      // todo: pare down this config object to just a theme
      pageSlug: 'courses',
      routeKey,
      courseSlug,
      lessonSlug,
      tabSlug,
    };

    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    window.JunoWidgetSettings.widgets.push({
      siteId: CrowdHub_App.CONFIG.VNEXT_SITE_ID,
      widget: 'juno_learning',
      mount: 'juno_learning',
      data: this.mData,
      timeCreated: this.timeCreated,
    });

    const newScript = document.createElement('script');
    newScript.src = CrowdHub_App.CONFIG.VNEXT_WIDGET_SCRIPT_SRC || `https://widgets.junolive.dev/junoWidgets.js`;
    this.mDiv.append(newScript);
  }

  private setupSubNav(): void {
    if (this.mData.showSubNav == true && this.mData.subNavItems != null && this.mData.subNavItems.length > 0) {
      this.mSubNavigation = new CustomSubNavigation();
      this.mSubNavigation.initialize({ items: this.mData.subNavItems, div: this.mDiv.find('.subnav_container') });
    }
  }

  onTransitionOut(): void {
    const widgetKey = 'juno_learning';
    window.JunoWidgetSettings = window.JunoWidgetSettings || {};
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets || [];
    const matchesWidget = widget => widget.widget === widgetKey && widget.timeCreated === this.timeCreated;
    const selectedWidget = window.JunoWidgetSettings.widgets.find(widget => matchesWidget(widget));
    window.JunoWidgetSettings.widgets = window.JunoWidgetSettings.widgets.filter(widget => !matchesWidget(widget));
    selectedWidget?.reactRoot?.unmount();
  }
}
